import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";

//components:
import GeneralData from "./GeneralData";
import MediaDashboard from "../MediaItemPage/MediaDashboard";
import Fade from "@material-ui/core/Fade";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

//actions:
import {errorActions} from "../../redux/ErrorHandler/errorHandler";
import {reviewActions} from "../../redux/Review/reviewRedux";
import {setHeaderImg, setLogo, setIsReviewPage} from "../../redux/Layout/layoutSlice";
import {loadParameter} from "../../redux_slices/contextSlice";

const Review = ({match}) => {
    const videoId = match.params.videoId;
    //redux:
    const dispatch = useDispatch();

    //store:
    const homePic = useSelector(state => loadParameter(state, "homePic"));
    const corporativeLogo = useSelector(state => loadParameter(state, "corporativeLogo"));

    const errorMessage = useSelector(state => state.error.errorMessage);

    useEffect(() => {
        dispatch(setHeaderImg(homePic));
        dispatch(setLogo(corporativeLogo));
        dispatch(setIsReviewPage(true));

        return () => {
            if (errorMessage) dispatch(errorActions.setErrorMessage(""));
            dispatch(setIsReviewPage(false));
            dispatch(reviewActions.clearReviewPage());
        };
    }, []);

    if (errorMessage)
        return (
            <div className="col-12 d-flex justify-content-center align-items-center py-10">
                <div className="alert alert-light text-dark w-fit-content">
                    <WarningRoundedIcon color="inherit" className="mr-5" />
                    {errorMessage}
                </div>
            </div>
        );

    return (
        <Fade in={!errorMessage} mountOnEnter={true} unmountOnExit={true} timeout={1000}>
            <div className="reviewPage container">
                <div className="row min-w-100">
                    <GeneralData videoId={videoId} />
                    <h3>Review Insights</h3>
                    <MediaDashboard match={match} page={"review"} />
                </div>
            </div>
        </Fade>
    );
};

Review.propTypes = {
    homePic: PropTypes.string,
    match: PropTypes.object,
    errorMessage: PropTypes.string,
};

export default Review;
